import { render, staticRenderFns } from "./OcrPreviewModal.vue?vue&type=template&id=52507ccc"
import script from "./OcrPreviewModal.vue?vue&type=script&lang=js"
export * from "./OcrPreviewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports